import { ProductGroupObj } from "scrivito/Objs/ProductGroup/ProductGroupObjClass"
import { SelectOption } from "shared/types/Select"
import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export enum ProductFilterType {
  PRODUCT_GROUP = "product-group",
  ROOM_TYPE = "room-type",
  BUILDING_TYPE = "building-type"
}

export interface ProductGroupFilterItem extends SelectOption<string> {
  key: string
  image?: React.ReactNode
  productGroupObj?: ProductGroupObj
  filterType: ProductFilterType.PRODUCT_GROUP
}

export interface RoomTypeFilterItem extends SelectOption<RoomType> {
  key: string
  filterType: ProductFilterType.ROOM_TYPE
}

export interface BuildingTypeFilterItem extends SelectOption<BuildingType> {
  key: string
  icon?: IconName
  filterType: ProductFilterType.BUILDING_TYPE
}

export type ProductFilterItem =
  | ProductGroupFilterItem
  | RoomTypeFilterItem
  | BuildingTypeFilterItem
